import { createContext } from 'react';

/**
 * Unified Match Context that handles both TCG and VGC matches
 */
const UnifiedMatchContext = createContext();

export default UnifiedMatchContext;